import { Mark, markInputRule } from '@tiptap/core';

interface MathOptions {
  HTMLAttributes: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    math: {
      /**
       * Set a math mark
       */
      setMath: () => ReturnType;
      /**
       * Toggle a math mark
       */
      toggleMath: () => ReturnType;
      /**
       * Unset a math mark
       */
      unsetMath: () => ReturnType;
    };
  }
}

const starInputRegex = /(?:^|\s)((?:\*\*)((?:[^*]+))(?:\*\*))$/;
const underscoreInputRegex = /(?:^|\s)((?:__)((?:[^__]+))(?:__))$/;

const mathType = 'math';

const Math = Mark.create<MathOptions>({
  name: mathType,

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  parseHTML() {
    return [
      {
        tag: 'math',
      },
    ];
  },

  addAttributes() {
    return {
      mathjax: {
        default: null,
      },
    };
  },

  renderHTML({ mark }) {
    const dom = document.createElement('span');
    dom.classList.add('mathjax');

    if (mark.attrs && mark.attrs.mathjax) {
      dom.innerHTML = mark.attrs.mathjax;
    }

    return dom;
  },

  addCommands() {
    return {
      setMath: () => ({ commands }) => {
        return commands.setMark(this.name);
      },
      toggleMath: () => ({ commands }) => {
        return commands.toggleMark(this.name);
      },
      unsetMath: () => ({ commands }) => {
        return commands.unsetMark(this.name);
      },
    };
  },

  addInputRules() {
    return [
      markInputRule({
        find: starInputRegex,
        type: this.type,
      }),
      markInputRule({
        find: underscoreInputRegex,
        type: this.type,
      }),
    ];
  },
});

export default { mark: Math, type: mathType };
